import type { ServiceLevelIdicatorWithHistory, ApiStatusService, ServiceStatusParams } from './types';
import delay from '../mockServiceDelay';

const fixtureData: ServiceLevelIdicatorWithHistory[] = [
  {
    sloId: '70fcb91c6ea05ee7a167917cae7ec0d6',
    serviceName: 'shipium-http-api-gateway',
    serviceDescription: 'The Shipium API gateway provides an HTTP and GraphQL API for the Partner Console.  ',
    serviceLevelIndicator: 99.9,
    from: 1586124120,
    to: 1588716120,
    monitorIds: [18071661],
    tags: ['env:stage'],
    healthy: false,
    state: 'DOWN',
    statusChangeTimestamp: 1588186462000,
  },
  {
    sloId: 'e73ba81c14885fb993515ef9a861ec39',
    serviceName: 'shiptime-api',
    serviceDescription:
      'The Shiptime API provides a programatic interface for partners to retrieve delivery estimates, submit orders, and shipments.',
    serviceLevelIndicator: 100,
    from: 1586124120,
    to: 1588716120,
    monitorIds: [18073819],
    tags: ['env:stage'],
    healthy: true,
    state: 'OK',
    statusChangeTimestamp: 1588091501000,
  },
];

export const mockApiStatusService: ApiStatusService = {
  async fetchApiStatus(params: ServiceStatusParams) {
    await delay();
    return fixtureData;
  },
};

export default mockApiStatusService;
